// Comprehensive fashion categories based on major retailers like Bloomingdale's

export const GENDER_CATEGORIES = [
  'Men',
  'Women',
  'Children'
] as const;

export const CLOTHING_TYPES = {
  // Women's Clothing
  WOMENS_TOPS: [
    'Blouses & Button-Down Shirts',
    'T-Shirts & Tank Tops',
    'Sweaters & Cardigans',
    'Hoodies & Sweatshirts',
    'Blazers & Suit Jackets',
    'Coats & Jackets',
    'Vests',
    'Tunics',
    'Bodysuits',
    'Crop Tops'
  ],
  WOMENS_BOTTOMS: [
    'Jeans',
    'Pants & Leggings',
    'Shorts',
    'Skirts',
    'Jumpsuits & Rompers'
  ],
  WOMENS_DRESSES: [
    'Casual Dresses',
    'Cocktail Dresses',
    'Evening Gowns',
    'Maxi Dresses',
    'Mini Dresses',
    'Midi Dresses',
    'Work Dresses',
    'Wedding Guest Dresses'
  ],
  WOMENS_INTIMATES: [
    'Bras',
    'Panties',
    'Shapewear',
    'Lingerie Sets',
    'Sleepwear & Robes',
    'Hosiery & Socks'
  ],
  
  // Men's Clothing
  MENS_TOPS: [
    'Dress Shirts',
    'Casual Shirts',
    'T-Shirts & Polos',
    'Sweaters & Cardigans',
    'Hoodies & Sweatshirts',
    'Suits & Sport Coats',
    'Blazers',
    'Vests',
    'Tank Tops'
  ],
  MENS_BOTTOMS: [
    'Dress Pants',
    'Casual Pants',
    'Jeans',
    'Shorts',
    'Activewear Bottoms'
  ],
  MENS_UNDERWEAR: [
    'Boxers',
    'Briefs',
    'Boxer Briefs',
    'Undershirts',
    'Sleepwear',
    'Socks'
  ],
  
  // Children's Clothing
  KIDS_TOPS: [
    'T-Shirts & Tanks',
    'Shirts & Blouses',
    'Sweaters & Hoodies',
    'Jackets & Coats'
  ],
  KIDS_BOTTOMS: [
    'Jeans & Pants',
    'Shorts',
    'Skirts & Skorts',
    'Leggings'
  ],
  KIDS_DRESSES: [
    'Casual Dresses',
    'Party Dresses',
    'School Dresses'
  ],
  
  // Shoes
  WOMENS_SHOES: [
    'Boots',
    'Sneakers',
    'Heels',
    'Flats',
    'Sandals',
    'Loafers',
    'Athletic Shoes',
    'Evening Shoes',
    'Wedges',
    'Mules & Slides'
  ],
  MENS_SHOES: [
    'Dress Shoes',
    'Casual Shoes',
    'Sneakers',
    'Boots',
    'Loafers',
    'Athletic Shoes',
    'Sandals & Flip-Flops',
    'Slippers'
  ],
  KIDS_SHOES: [
    'Sneakers',
    'Dress Shoes',
    'Boots',
    'Sandals',
    'Athletic Shoes',
    'School Shoes'
  ],
  
  // Accessories
  ACCESSORIES: [
    'Handbags & Purses',
    'Wallets & Small Accessories',
    'Jewelry',
    'Watches',
    'Sunglasses',
    'Hats & Caps',
    'Scarves & Wraps',
    'Belts',
    'Hair Accessories',
    'Tech Accessories'
  ],
  
  // Outerwear
  OUTERWEAR: [
    'Winter Coats',
    'Leather Jackets',
    'Denim Jackets',
    'Blazers',
    'Cardigans',
    'Vests',
    'Raincoats',
    'Parkas',
    'Peacoats',
    'Trench Coats'
  ]
} as const;

export const FASHION_BRANDS = [
  '7 For All Mankind',
  'Abercrombie & Fitch',
  'Acne Studios',
  'Adidas',
  'Aerie',
  'Aeropostale',
  'AG Jeans',
  'Agolde',
  'Alice + Olivia',
  'Alo Yoga',
  'American Eagle',
  'And Other Stories',
  'Ann Taylor',
  'Anthropologie',
  'APL',
  'Aquazzura',
  'Arc\'teryx',
  'Arket',
  'Armani',
  'ASOS',
  'Asics',
  'Athleta',
  'Ba&sh',
  'Balenciaga',
  'Banana Republic',
  'Bar III',
  'BaubleBar',
  'BCBG',
  'BCBGMAXAZRIA',
  'Betsey Johnson',
  'Beyond Yoga',
  'Birkenstock',
  'Bloomingdale\'s',
  'Bobo Choses',
  'Bonpoint',
  'Bottega Veneta',
  'Brandy Melville',
  'Brioni',
  'Brooks Brothers',
  'Brunello Cucinelli',
  'Bulgari',
  'Burberry',
  'Burberry Kids',
  'By Malene Birger',
  'Calvin Klein',
  'Calvin Klein Jeans',
  'Canada Goose',
  'Canali',
  'Caramel',
  'Cartier',
  'Celine',
  'Champion',
  'Chanel',
  'Charter Club',
  'Christian Louboutin',
  'Citizens of Humanity',
  'Clinique',
  'Club Monaco',
  'Coach',
  'Common Projects',
  'Converse',
  'COS',
  'CP Company',
  'Custom Made',
  'David Yurman',
  'DKNY',
  'Diane von Furstenberg',
  'Dior',
  'Dolce & Gabbana',
  'Dr. Martens',
  'Equipment',
  'Ermenegildo Zegna',
  'Essentials',
  'Estee Lauder',
  'Everlane',
  'Express',
  'Fear of God',
  'Fendi',
  'Finger in the Nose',
  'Forever 21',
  'Fossil',
  'Frame',
  'Free People',
  'Gap',
  'Ganni',
  'Gianvito Rossi',
  'Girlfriend Collective',
  'Givenchy',
  'Golden Goose',
  'Good American',
  'Gorjana',
  'Grlfrnd',
  'Gucci',
  'Gucci Kids',
  'Guess',
  'H&M',
  'Hanes',
  'Hermès',
  'Hollister',
  'Hugo Boss',
  'Hundred Pieces',
  'I.N.C. International Concepts',
  'IRO',
  'Isabel Marant',
  'Isaia',
  'J Brand',
  'J.Crew',
  'Jacquemus',
  'Jennifer Fisher',
  'Jennifer Meyer',
  'Jimmy Choo',
  'Juicy Couture',
  'JW Anderson',
  'Kate Spade',
  'Kendra Scott',
  'Kenneth Cole',
  'Khaite',
  'Kiton',
  'Ksubi',
  'Lacoste',
  'Lauren Ralph Lauren',
  'Lemaire',
  'Levi\'s',
  'Loewe',
  'Loft',
  'Louis Vuitton',
  'Lucky Brand',
  'Lululemon',
  'MAC Cosmetics',
  'Macy\'s',
  'Madewell',
  'Maje',
  'Manolo Blahnik',
  'Marc Ecko',
  'Marc Jacobs',
  'Massimo Dutti',
  'Maison Margiela',
  'Mejuri',
  'Michael Kors',
  'Mini Rodini',
  'Missoma',
  'MM6 Maison Margiela',
  'Moncler',
  'Moncler Kids',
  'Monica Vinader',
  'Mother',
  'MSGM',
  'Nanushka',
  'Nautica',
  'Neiman Marcus',
  'New Balance',
  'Nike',
  'Nine West',
  'No Brand/Unbranded',
  'Nordstrom',
  'Off-White',
  'Old Navy',
  'On Running',
  'Other',
  'Outdoor Voices',
  'P.E Nation',
  'Paige',
  'Pandora',
  'Patagonia',
  'PacSun',
  'Polo Ralph Lauren',
  'Prada',
  'Puma',
  'Rag & Bone',
  'Ralph Lauren',
  'Ralph Lauren Kids',
  'Re/Done',
  'Rebecca Minkoff',
  'Reebok',
  'Reformation',
  'Rotate',
  'Saint Laurent',
  'Saks Fifth Avenue',
  'Salvatore Ferragamo',
  'Sandro',
  'Scotch & Soda',
  'Sean John',
  'Self-Portrait',
  'Sergio Rossi',
  'Shein',
  'Skims',
  'Staud',
  'Stella McCartney Kids',
  'Steve Madden',
  'Stone Island',
  'Stone Island Junior',
  'Stuart Weitzman',
  'Style & Co',
  'Swarovski',
  'Sweaty Betty',
  'Target',
  'The Animals Observatory',
  'The North Face',
  'The Row',
  'Theory',
  'Thom Browne',
  'Thrifted',
  'Tiffany & Co.',
  'Timberland',
  'Tiny Cottons',
  'Tod\'s',
  'Tom Ford',
  'Tommy Bahama',
  'Tommy Hilfiger',
  'Topshop',
  'Tory Burch',
  'Toteme',
  'UGG',
  'Under Armour',
  'Uniqlo',
  'Urban Outfitters',
  'Valentino',
  'Van Cleef & Arpels',
  'Vans',
  'Varley',
  'Veja',
  'Versace',
  'Victoria\'s Secret',
  'Vince',
  'Vintage',
  'Wolf & Rita',
  'Zara'
] as const;

// Helper function to get all clothing types as a flat array
export const getAllClothingTypes = (): string[] => {
  return Object.values(CLOTHING_TYPES).flat();
};

// Helper function to get clothing types by gender
export const getClothingTypesByGender = (gender: string): string[] => {
  switch (gender.toLowerCase()) {
    case 'women':
      return [
        ...CLOTHING_TYPES.WOMENS_TOPS,
        ...CLOTHING_TYPES.WOMENS_BOTTOMS,
        ...CLOTHING_TYPES.WOMENS_DRESSES,
        ...CLOTHING_TYPES.WOMENS_INTIMATES,
        ...CLOTHING_TYPES.WOMENS_SHOES,
        ...CLOTHING_TYPES.ACCESSORIES,
        ...CLOTHING_TYPES.OUTERWEAR
      ];
    case 'men':
      return [
        ...CLOTHING_TYPES.MENS_TOPS,
        ...CLOTHING_TYPES.MENS_BOTTOMS,
        ...CLOTHING_TYPES.MENS_UNDERWEAR,
        ...CLOTHING_TYPES.MENS_SHOES,
        ...CLOTHING_TYPES.ACCESSORIES,
        ...CLOTHING_TYPES.OUTERWEAR
      ];
    case 'children':
      return [
        ...CLOTHING_TYPES.KIDS_TOPS,
        ...CLOTHING_TYPES.KIDS_BOTTOMS,
        ...CLOTHING_TYPES.KIDS_DRESSES,
        ...CLOTHING_TYPES.KIDS_SHOES,
        ...CLOTHING_TYPES.ACCESSORIES,
        ...CLOTHING_TYPES.OUTERWEAR
      ];
    default:
      return getAllClothingTypes();
  }
};

export type GenderCategory = typeof GENDER_CATEGORIES[number];
export type ClothingType = string;
export type FashionBrand = typeof FASHION_BRANDS[number];